<cbc-container [isLoading]="isLoadingProfile" [showContainer]="!isLoadingProfile" title="Dashboard"
  description="Painel empresa">
</cbc-container>
@if(!isLoadingProfile) {
<div class="container" [class.is_mobile]="isMobile">

  <!-- Header com saudação -->
  <div class="card dashboard-header">
    <div class="header-content">
      <div class="header-text">
        @if(profileProviderPJ && profileProviderPJ.companyMarketingName) {
        <div class="title-primary">Olá, {{ profileProviderPJ.companyMarketingName }}!</div>
        }
        <div class="title-primary-description">Bem-vindo de volta ao seu painel</div>
      </div>
      @if(profileProviderPJ && profileProviderPJ.certifiedHubMedical) {
      <div class="certification-badge">
        <img src="assets/icons/icon_certificado_concedido.svg" alt="Certificado Hub Medical" width="48px" />
        <span>Certificado</span>
      </div>
      }
    </div>
  </div>

  <!-- Stats Grid - Estatísticas Rápidas -->
  <div class="stats-grid">
    <!-- Documentos Compartilhados -->
    @if(profileProviderPJ && hasFeatureAccess(profileProviderPJ.cnpj, Feature.SHARE_DOCUMENTS)) {
    <div class="stat-card card">
      <div class="stat-icon">
        <img src="assets/icons/icon_ph_files_duo.svg" alt="Documentos Compartilhados" />
      </div>
      <div class="stat-content">
        <div class="stat-value">{{ totalDocuments }}</div>
        <div class="stat-label">Documentos Compartilhados</div>
      </div>
    </div>
    }

    <!-- Ofertas de Serviços -->
    @if(profileProviderPJ && hasFeatureAccess(profileProviderPJ.cnpj, Feature.SERVICE_OFFERING)) {
    <div class="stat-card card">
      <div class="stat-icon">
        <img src="assets/icons/icon_ph_briefcase_duo.svg" alt="Ofertas de Serviços" />
      </div>
      <div class="stat-content">
        <div class="stat-value">{{ serviceOfferingList.length || 0 }}</div>
        <div class="stat-label">Ofertas de Serviços</div>
      </div>
    </div>
    }

    <!-- Ofertas de Recursos -->
    @if(profileProviderPJ && hasFeatureAccess(profileProviderPJ.cnpj, Feature.RESOURCE_OFFERING)) {
    <div class="stat-card card">
      <div class="stat-icon">
        <img src="assets/icons/icon_ph_package_duo.svg" alt="Ofertas de Recursos" />
      </div>
      <div class="stat-content">
        <div class="stat-value">{{ resourceOfferingList.length || 0 }}</div>
        <div class="stat-label">Ofertas de Recursos</div>
      </div>
    </div>
    }

    <!-- Demandas de Serviços -->
    @if(profileProviderPJ && hasFeatureAccess(profileProviderPJ.cnpj, Feature.SERVICE_DEMAND)) {
    <div class="stat-card card">
      <div class="stat-icon">
        <img src="assets/icons/icon_ph_clipboard_text_duo.svg" alt="Demandas de Serviços" />
      </div>
      <div class="stat-content">
        <div class="stat-value">{{ serviceDemandList.length || 0 }}</div>
        <div class="stat-label">Demandas de Serviços</div>
      </div>
    </div>
    }

    <!-- Demandas de Recursos -->
    @if(profileProviderPJ && hasFeatureAccess(profileProviderPJ.cnpj, Feature.RESOURCE_DEMAND)) {
    <div class="stat-card card">
      <div class="stat-icon">
        <img src="assets/icons/icon_ph_cube_duo.svg" alt="Demandas de Recursos" />
      </div>
      <div class="stat-content">
        <div class="stat-value">{{ resourceDemandList.length || 0 }}</div>
        <div class="stat-label">Demandas de Recursos</div>
      </div>
    </div>
    }

    <!-- Negociações -->
    @if(profileProviderPJ && hasFeatureAccess(profileProviderPJ.cnpj, Feature.NEGOTIATION)) {
    <div class="stat-card card">
      <div class="stat-icon">
        <img src="assets/icons/icon_ph_handshake_duo.svg" alt="Negociações" />
      </div>
      <div class="stat-content">
        <div class="stat-value">{{ negotiations.length || 0 }}</div>
        <div class="stat-label">Negociações</div>
      </div>
    </div>
    }
  </div>

  <!-- Menu de Acesso Rápido -->
  <div class="title-section">Acesso Rápido</div>
  <div class="menu-grid">
    <!-- Meu Perfil -->
    @if(profileProviderPJ && canAccess(profileProviderPJ.cnpj)) {
    <a [routerLink]="['/my-account/profiles/profileProviderPJForm', profileProviderPJ.id]" class="menu-item">
      <div class="menu-icon">
        <img src="assets/icons/icon_ph_buildings_duo.svg" alt="Meu Perfil" />
      </div>
      <span class="menu-label">Meu Perfil</span>
    </a>
    }

    <!-- Compartilhamentos -->
    @if(profileProviderPJ && hasFeatureAccess(profileProviderPJ.cnpj, Feature.SHARE_DOCUMENTS)) {
    <a routerLink="shareDocuments" class="menu-item">
      <div class="menu-icon">
        <img src="assets/icons/icon_ph_share_network_duo.svg" alt="Compartilhamentos" />
      </div>
      <span class="menu-label">Compartilhamentos</span>
    </a>
    }

    <!-- Ofertas de Serviços -->
    @if(profileProviderPJ && hasFeatureAccess(profileProviderPJ.cnpj, Feature.SERVICE_OFFERING)) {
    <a routerLink="serviceOffering" class="menu-item">
      <div class="menu-icon">
        <img src="assets/icons/icon_ph_briefcase_duo.svg" alt="Ofertas de Serviços" />
      </div>
      <span class="menu-label">Ofertas de Serviços</span>
    </a>
    }

    <!-- Ofertas de Recursos -->
    @if(profileProviderPJ && hasFeatureAccess(profileProviderPJ.cnpj, Feature.RESOURCE_OFFERING)) {
    <a routerLink="resourceOffering" class="menu-item">
      <div class="menu-icon">
        <img src="assets/icons/icon_ph_package_duo.svg" alt="Ofertas de Recursos" />
      </div>
      <span class="menu-label">Ofertas de Recursos</span>
    </a>
    }

    <!-- Demandas de Serviços -->
    @if(profileProviderPJ && hasFeatureAccess(profileProviderPJ.cnpj, Feature.SERVICE_DEMAND)) {
    <a routerLink="serviceDemand" class="menu-item">
      <div class="menu-icon">
        <img src="assets/icons/icon_ph_clipboard_text_duo.svg" alt="Demandas de Serviços" />
      </div>
      <span class="menu-label">Demandas de Serviços</span>
    </a>
    }

    <!-- Demandas de Recursos -->
    @if(profileProviderPJ && hasFeatureAccess(profileProviderPJ.cnpj, Feature.RESOURCE_DEMAND)) {
    <a routerLink="resourceDemand" class="menu-item">
      <div class="menu-icon">
        <img src="assets/icons/icon_ph_cube_duo.svg" alt="Demandas de Recursos" />
      </div>
      <span class="menu-label">Demandas de Recursos</span>
    </a>
    }

    <!-- Negociações -->
    @if(profileProviderPJ && hasFeatureAccess(profileProviderPJ.cnpj, Feature.NEGOTIATION)) {
    <a [routerLink]="['/providerPJ', profileProviderPJ.id, 'negotiationPainel', encriptCpfcnpj(profileProviderPJ.cnpj!)]"
      class="menu-item">
      <div class="menu-icon">
        <img src="assets/icons/icon_ph_handshake_duo.svg" alt="Negociações" />
      </div>
      <span class="menu-label">Negociações</span>
    </a>
    }
  </div>
  <br>
  <!-- Seção de Documentos Compartilhados -->
  @if(profileProviderPJ && hasFeatureAccess(profileProviderPJ.cnpj, Feature.SHARE_DOCUMENTS)) {
  <div class="card">
    <div class="card-header">
      <h3 class="card-title">Documentos Compartilhados</h3>
      <button mat-stroked-button routerLink="shareDocuments" class="btn-outline">
        <mat-icon>arrow_forward</mat-icon>
        Ver Todos
      </button>
    </div>
    <div class="card-body">
      @if(documentSharing && documentSharing.length > 0) {
      @for (document of documentSharing.slice(0, 3); track $index) {
      <div class="file-card">
        <div class="file-icon">
          <img src="assets/icons/icon_folders_DUO.svg" alt="Documento" />
        </div>
        <div class="file-info">
          @if(document.ownerDocumentsCpfCnpj && document.ownerDocumentsCpfCnpj.length === 14) {
          <div class="file-title-wrapper">
            <h4 class="file-title">{{ getCompanyDto(document.ownerDocumentsCpfCnpj).companyName }}</h4>
            @if(getCompanyDto(document.ownerDocumentsCpfCnpj).certifiedHubMedical) {
            <img src="assets/icons/icon_certificado_concedido.svg" alt="Certificado" class="certification-icon"
              width="20" height="20" />
            }
          </div>
          } @else if(document.ownerDocumentsCpfCnpj && document.ownerDocumentsCpfCnpj.length === 11) {
          <div class="file-title-wrapper">
            <h4 class="file-title">{{ getProfilePFDto(document.ownerDocumentsCpfCnpj).name }}</h4>
            @if(getProfilePFDto(document.ownerDocumentsCpfCnpj).certifiedHubMedical) {
            <img src="assets/icons/icon_certificado_concedido.svg" alt="Certificado" class="certification-icon"
              width="20" height="20" />
            }
          </div>
          }
          <div class="file-meta">
            <p class="file-date">
              {{ document.active ? 'Ativo desde' : 'Inativo desde' }}
              {{ (document.active ? document.grantedDate : document.revokedDate) | date: 'dd/MM/yyyy' }}
            </p>
            <span class="badge" [ngClass]="document.active ? 'badge-success' : 'badge-error'">
              {{ document.active ? 'Ativo' : 'Inativo' }}
            </span>
          </div>
        </div>
        @if(document.active && document.grantedDate && !document.revokedDate) {
        <div class="file-actions">
          <button mat-icon-button color="primary" (click)="viewDocuments(document)" matTooltip="Ver documentos">
            <mat-icon>visibility</mat-icon>
          </button>
        </div>
        }
      </div>
      }
      } @else {
      <div class="empty-state">
        <mat-icon>folder_off</mat-icon>
        <p>Você ainda não tem documentos compartilhados</p>
      </div>
      }
    </div>
  </div>
  }
  <br>
  <!-- Seção de Ofertas de Serviços -->
  @if(profileProviderPJ && hasFeatureAccess(profileProviderPJ.cnpj, Feature.SERVICE_OFFERING)) {
  <div class="card">
    <div class="card-header">
      <h3 class="card-title">Ofertas de Serviços</h3>
      <button mat-stroked-button routerLink="serviceOffering" class="btn-outline">
        <mat-icon>arrow_forward</mat-icon>
        Ver Todas
      </button>
    </div>
    <div class="card-body">
      @if(serviceOfferingList && serviceOfferingList.length > 0) {
      <div class="offers-list">
        @for (offer of serviceOfferingList.slice(0, 3); track $index) {
        <div class="offer-item">
          <div class="offer-info">
            <h4 class="offer-title">{{ offer.professionName }}</h4>
            <div class="offer-meta">
              <span class="badge badge-primary">{{ offer.specialty }}</span>
              @if(!offer.publicationDate) {
              <span class="badge badge-warning">Não Publicado</span>
              }
            </div>
            @if(offer.publicationDate) {
            <p class="offer-date">Publicado em {{ offer.publicationDate | date: 'dd/MM/yyyy' }}</p>
            }
          </div>
        </div>
        }
      </div>
      } @else {
      <div class="empty-state">
        <mat-icon>local_offer</mat-icon>
        <p>Você ainda não tem ofertas de serviços cadastradas</p>
      </div>
      }
    </div>
  </div>
  }
  <br>
  <!-- Seção de Ofertas de Recursos -->
  @if(profileProviderPJ && hasFeatureAccess(profileProviderPJ.cnpj, Feature.RESOURCE_OFFERING)) {
  <div class="card">
    <div class="card-header">
      <h3 class="card-title">Ofertas de Recursos</h3>
      <button mat-stroked-button routerLink="resourceOffering" class="btn-outline">
        <mat-icon>arrow_forward</mat-icon>
        Ver Todas
      </button>
    </div>
    <div class="card-body">
      @if(resourceOfferingList && resourceOfferingList.length > 0) {
      <div class="offers-list">
        @for (offer of resourceOfferingList.slice(0, 3); track $index) {
        <div class="offer-item">
          <div class="offer-info">
            <h4 class="offer-title">{{ offer.resource?.join(', ') }}</h4>
            <div class="offer-meta">
              @if(!offer.publicationDate) {
              <span class="badge badge-warning">Não Publicado</span>
              }
            </div>
            @if(offer.publicationDate) {
            <p class="offer-date">Publicado em {{ offer.publicationDate | date: 'dd/MM/yyyy' }}</p>
            }
          </div>
        </div>
        }
      </div>
      } @else {
      <div class="empty-state">
        <mat-icon>local_offer</mat-icon>
        <p>Você ainda não tem ofertas de recursos cadastradas</p>
      </div>
      }
    </div>
  </div>
  }
  <br>
  <!-- Seção de Demandas de Serviços -->
  @if(profileProviderPJ && hasFeatureAccess(profileProviderPJ.cnpj, Feature.SERVICE_DEMAND)) {
  <div class="card">
    <div class="card-header">
      <h3 class="card-title">Demandas de Serviços</h3>
      <button mat-stroked-button routerLink="serviceDemand" class="btn-outline">
        <mat-icon>arrow_forward</mat-icon>
        Ver Todas
      </button>
    </div>
    <div class="card-body">
      @if(serviceDemandList && serviceDemandList.length > 0) {
      <div class="offers-list">
        @for (demand of serviceDemandList.slice(0, 3); track $index) {
        <div class="offer-item">
          <div class="offer-info">
            <h4 class="offer-title">{{ demand.professionName }}</h4>
            <div class="offer-meta">
              <span class="badge badge-primary">{{ demand.specialty }}</span>
            </div>
            @if(demand.publicationDate) {
            <p class="offer-date">Publicado em {{ demand.publicationDate | date: 'dd/MM/yyyy' }}</p>
            }
          </div>
        </div>
        }
      </div>
      } @else {
      <div class="empty-state">
        <mat-icon>local_offer</mat-icon>
        <p>Você ainda não tem demandas de serviços cadastradas</p>
      </div>
      }
    </div>
  </div>
  }
  <br>
  <!-- Seção de Demandas de Recursos -->
  @if(profileProviderPJ && hasFeatureAccess(profileProviderPJ.cnpj, Feature.RESOURCE_DEMAND)) {
  <div class="card">
    <div class="card-header">
      <h3 class="card-title">Demandas de Recursos</h3>
      <button mat-stroked-button routerLink="resourceDemand" class="btn-outline">
        <mat-icon>arrow_forward</mat-icon>
        Ver Todas
      </button>
    </div>
    <div class="card-body">
      @if(resourceDemandList && resourceDemandList.length > 0) {
      <div class="offers-list">
        @for (demand of resourceDemandList.slice(0, 3); track $index) {
        <div class="offer-item">
          <div class="offer-info">
            <h4 class="offer-title">{{ demand.resource?.join(', ') }}</h4>
            @if(demand.publicationDate) {
            <p class="offer-date">Publicado em {{ demand.publicationDate | date: 'dd/MM/yyyy' }}</p>
            }
          </div>
        </div>
        }
      </div>
      } @else {
      <div class="empty-state">
        <mat-icon>local_offer</mat-icon>
        <p>Você ainda não tem demandas de recursos cadastradas</p>
      </div>
      }
    </div>
  </div>
  }
  <br>
  <!-- Seção de Negociações -->
  @if(profileProviderPJ && hasFeatureAccess(profileProviderPJ.cnpj, Feature.NEGOTIATION)) {
  <div class="card">
    <div class="card-header">
      <h3 class="card-title">Negociações Recentes</h3>
      <button mat-stroked-button
        [routerLink]="['/providerPJ', profileProviderPJ.id, 'negotiationPainel', encriptCpfcnpj(profileProviderPJ.cnpj!)]"
        class="btn-outline">
        <mat-icon>arrow_forward</mat-icon>
        Ver Todas
      </button>
    </div>
    <div class="card-body">
      @if(negotiations && negotiations.length > 0) {
      <div class="negotiations-list">
        @for (negotiation of negotiations.slice(0, 3); track $index) {
        <div class="negotiation-item">
          <div class="negotiation-info">
            <h4 class="negotiation-title">{{ getParticipantDtoName(negotiation) }}</h4>
            <div class="negotiation-meta">
              <span class="badge badge-primary">{{ getNegotiationStatusDescription(negotiation.status) }}</span>
              <p class="negotiation-date">{{ negotiation.createdAt | date: 'dd/MM/yyyy HH:mm' }}</p>
            </div>
            <p class="negotiation-message">{{ negotiation.initialMessage }}</p>
          </div>
        </div>
        }
      </div>
      } @else {
      <div class="empty-state">
        <mat-icon>forum</mat-icon>
        <p>Você ainda não tem negociações</p>
      </div>
      }
    </div>
  </div>
  }
</div>
}

